import React from 'react'
import { Controller } from 'react-hook-form'
import { Select, SelectWithFilteredOptionsDropdownProps } from '~components/ui/molecules/select'
import { DropdownOption } from '~components/ui/molecules/dropdown'
import { ControlledProps } from '../types'
import { SelectError } from './styles'

export interface ControlledSelectWithFilteredOptionsDropdownProps<TFormValues>
  extends ControlledProps<TFormValues>,
    SelectWithFilteredOptionsDropdownProps {
  defaultSelectValue?: DropdownOption
}

export const ControlledSelectWithFilteredOptionsDropdown = <TFormValues extends Record<string, unknown>>({
  rules,
  control,
  name,
  options,
  errors,
  defaultSelectValue,
  ...selectProps
}: ControlledSelectWithFilteredOptionsDropdownProps<TFormValues>): JSX.Element => (
  <Controller
    rules={rules}
    control={control}
    name={name}
    defaultValue={defaultSelectValue}
    render={({ field }) => (
      <>
        <Select.WithFilteredOptionsDropdown
          {...selectProps}
          options={options}
          onChange={field.onChange}
          onBlur={field.onBlur}
          value={options.find((option) => field.value === option.id || defaultSelectValue)}
        />
        {errors?.[name] && <SelectError>{errors?.[name]?.message}</SelectError>}
      </>
    )}
  />
)
